import { atom } from "jotai";

import { ValidateBookingRulesInput } from "@whoosh/features/src/Restrictions/hooks/useValidateBookingRules/__generated__/useValidateBookingRulesMutation.graphql";

import {
  currentBookingAtom,
  originalBookingOwnerClientIdAtom,
} from "../../stores";
import { updatedCustomerRoundsAtom } from "../UpdatePayloads/UpdatedRounds/UpdatedCustomerRounds/UpdatedCustomerRoundsAtom";
import { updatedGuestRoundsAtom } from "../UpdatePayloads/UpdatedRounds/UpdatedGuestRoundsAtom/UpdatedGuestRoundsAtom";
import { updatedMemberRoundsAtom } from "../UpdatePayloads/UpdatedRounds/UpdatedMemberRoundsAtom/UpdatedMemberRoundsAtom";
import { updatedNewGuestRoundsAtom } from "../UpdatePayloads/UpdatedRounds/UpdatedNewGuestRoundsAtom/UpdatedNewGuestRoundsAtom";

const getRequestInput = (
  request:
    | {
        time?: string;
        minTime?: string;
        maxTime?: string;
      }
    | undefined
): ValidateBookingRulesInput["request"] | undefined => {
  if (!request?.time || !request.minTime || !request.maxTime) {
    return undefined;
  }

  return {
    time: request.time,
    minTime: request.minTime,
    maxTime: request.maxTime,
  };
};

export const validateRestrictionsInputAtom =
  atom<ValidateBookingRulesInput | null>((get) => {
    const currentBooking = get(currentBookingAtom);
    const startSlotId = currentBooking?.startSlotId;

    if (!currentBooking || !startSlotId) return null;

    const updatedCustomerRounds = get(updatedCustomerRoundsAtom);
    const updatedMemberRounds = get(updatedMemberRoundsAtom);
    const updatedGuestRounds = get(updatedGuestRoundsAtom);
    const updatedNewGuestRounds = get(updatedNewGuestRoundsAtom);
    const ownerRound = currentBooking.rounds.find((r) => r.isOwner);
    const ownerClientId =
      ownerRound?.player?.id ?? get(originalBookingOwnerClientIdAtom);

    const isLessonBooking = currentBooking.type === "Lesson";
    const request = isLessonBooking
      ? getRequestInput(currentBooking.request)
      : undefined;

    const validateRestrictionsInput: ValidateBookingRulesInput = {
      bookingId: currentBooking.id,
      customerRounds: updatedCustomerRounds,
      ownerClientId: ownerClientId ?? undefined,
      startSlotId: startSlotId,
      type: isLessonBooking ? "LESSON" : "STANDARD",
      durationMins: currentBooking.durationMins,
      rateId: currentBooking.rateId,
      memberRounds: updatedMemberRounds,
      guestRounds: updatedGuestRounds,
      newGuestRounds: updatedNewGuestRounds,
      ...(request ? { request } : {}),
    };

    return validateRestrictionsInput;
  });
